import { render, staticRenderFns } from "./InsightWidget.vue?vue&type=template&id=c159ecf4&scoped=true&"
import script from "./InsightWidget.vue?vue&type=script&lang=js&"
export * from "./InsightWidget.vue?vue&type=script&lang=js&"
import style0 from "./InsightWidget.vue?vue&type=style&index=0&id=c159ecf4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c159ecf4",
  null
  
)

export default component.exports